﻿export default function ErrorBaseLayout({ children }) {
  return (
    <div className="max-w-full pl-[95px] pt-[100px]">
      <div className="error-base-layout__content">{children}</div>
    </div>
  );
}
